import React from 'react';

import { MetricsRendererSubAndSuper, MetricsRendererSubAndSuperProps } from './subAndSuper';

interface MetricsRendererErrorProps extends Omit<MetricsRendererSubAndSuperProps, 'showSigns'> {}

export function MetricsRendererError(props: MetricsRendererErrorProps) {
    return <MetricsRendererSubAndSuper {...props} showSigns={true} />;
}
